<div
  class="moderator-room-container"
  *requireAccess="
    'display:screenSharingModerator';
    entityId: displayId;
    allowSharedAccess: true
  "
  rvSpinner="moderator-join"
  [rvShowSpinner]="screenSharingService.connecting"
>
  <div class="flex flex-row space-between tw-h-[72px]">
    <h1
      class="tw-text-lg tw-leading-6 tw-font-semibold tw-ml-[25px] tw-my-[15px]"
      id="title"
    >
      @if (additionalDisplayCount > 0) {
        Connected to {{ additionalDisplayCount + 1 }} displays
      } @else {
        {{ displayName }}
      }
    </h1>
    <div class="tw-mr-5">
      <button matButton="outlined" class="button-role--danger" (click)="end()">
        <mat-icon svgIcon="sign-out" aria-hidden="true"></mat-icon>
        End Session for all
      </button>
    </div>
  </div>
  @if (screenSharingService.channelError) {
    <div class="alert alert-danger">
      {{ screenSharingService.channelError }}
    </div>
  }
  <div class="room-grid tw-flex tw-flex-col md:!tw-flex-row">
    <div class="room-controls tw-flex-1 md:!tw-w-[25%] md:!tw-flex-none">
      <screen-sharing-controls
        [isStopped]="stopped"
        [isPaused]="paused"
        [isModerator]="true"
        (startStream)="start()"
        (pauseStream)="pause()"
        (resumeStream)="resume()"
        (stopStream)="stop()"
        (endSession)="end()"
        class="tw-w-full"
      >
      </screen-sharing-controls>
    </div>
    <div
      class="tw-bg-gray-100 tw-p-[30px] tw-pb-5 tw-flex-1 md:!tw-w-[75%] md:!tw-flex-none"
    >
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-5">
        <strong class="tw-text-[15px] tw-font-semibold tw-text-black">
          {{ screenSharingService.participants?.length ?? 0 }} Participants
        </strong>
        <div class="tw-flex tw-items-center tw-gap-2.5">
          <span class="tw-text-[15px] tw-text-gray-900"
            >Allow others to join</span
          >
          <mat-slide-toggle
            color="primary"
            (change)="allowOthersToJoinChange($event.checked)"
            [checked]="screenSharingService.allowOthersToJoin"
          ></mat-slide-toggle>
        </div>
      </div>
      <div class="room-list">
        @for (
          user of screenSharingService.participants;
          track user.memberId;
          let i = $index
        ) {
          <div
            class="tw-flex tw-justify-between tw-items-center tw-p-2.5 tw-px-[15px] tw-bg-white tw-border tw-border-gray-200 tw-rounded-[7.5px] tw-shadow-sm hover:tw-shadow-md tw-transition-shadow"
          >
            <div
              class="tw-flex tw-items-center tw-gap-2.5 tw-flex-1 tw-min-w-0"
            >
              <initials-badge
                [name]="user.memberDisplayName"
                [size]="44"
              ></initials-badge>
              <div class="tw-flex tw-items-center tw-min-w-0">
                <span
                  class="tw-text-[15px] tw-font-medium tw-text-gray-900 tw-truncate"
                >
                  {{ user.memberDisplayName }}
                </span>
                @if (user.memberId === screenSharingService.memberId) {
                  <span
                    class="tw-text-[15px] tw-text-gray-600 tw-whitespace-nowrap"
                  >
                    &nbsp;(me)</span
                  >
                }
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-gap-[5px] tw-flex-shrink-0">
              <button
                rv-button
                class="user-action-button"
                [disabled]="
                  screenSharingService.sharing?.memberId === user.memberId ||
                  screenSharingService.invitedId === user.memberId
                "
                (click)="share(user.memberId)"
              >
                @if (screenSharingService.invitedId === user.memberId) {
                  <mat-spinner diameter="15" class="white"></mat-spinner>
                } @else {
                  {{
                    screenSharingService.memberId === user.memberId
                      ? 'Share'
                      : 'Invite'
                  }}
                }
              </button>
              <button
                mat-icon-button
                aria-label="Remove user"
                class="user-remove-button"
                (click)="remove(user.memberId)"
              >
                <mat-icon svgIcon="close"></mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
